import Widget from "csi/table/Widget";
import declare from "dojo/_base/declare";
import Sourcing from "./main";
import xml from "csi/xml";
import locale from "csi/locale";
import Key from "csi/core/Key";
import { C8AttributeKey } from "src/c8-platform/type/value";

const SRMSupplierRequestsTable = declare(Widget, {
	/**
	 * @override
	 * Don't render SupplierFactory heading on Supplier SR subtypes
	 */
	onViewResolveKeysToSkip(skipSet: Set<C8AttributeKey>): void {
		const viewNode = this.getViewNode();
		if (viewNode && Sourcing.isSubtypeSupplierSourced(viewNode.SRSubtype)) {
			skipSet.add(Key.untypedKeyFromParts({ id: "SRSupplierFactories" }));
		}
	},

	/**
    * @override
    * Update heading names
    */
	onViewStart() {
		const viewNode = this.getViewNode();
		if (viewNode) {
			const requestType = xml.enumGetText(viewNode.RequestType);
			const lineItemsHeading = this.attributeSpecs?.find({ id: "LineItems" })?.heading;
			if (lineItemsHeading) {
				lineItemsHeading.m_name = locale.typePlural(requestType);
				const nodeNameSubHeading = lineItemsHeading.getSubHeading("Node Name");
				if (nodeNameSubHeading) {
					nodeNameSubHeading.m_name = locale.resource(requestType);
				}
			}
		}
		this.inherited(arguments);
	},
});

export = SRMSupplierRequestsTable;